<template>
  <div class="mt-4 mx-4">
    <v-row class="mb-4">
      <v-col cols="auto">
        <v-chip :color="status === 'published' ? 'green' : 'grey'" dark>
          {{ status === 'published' ? '公開中' : '下書き' }}
        </v-chip>
      </v-col>
    </v-row>

    <v-row class="mb-4">
      <v-col cols="auto">
        <v-btn
          color="primary"
          small
          :loading="composing"
          @click="compose"
        >
          プレビュー生成
        </v-btn>
      </v-col>
      <v-col cols="auto">
        <v-btn
          v-if="status !== 'published'"
          color="green"
          dark
          small
          :disabled="!hasPdf"
          :loading="publishing"
          @click="publish"
        >
          公開する
        </v-btn>
        <v-btn
          v-else
          color="orange"
          dark
          small
          :loading="unpublishing"
          @click="unpublish"
        >
          非公開にする
        </v-btn>
      </v-col>
    </v-row>

    <v-tabs v-model="pdfTab" color="secondary">
      <v-tab v-for="group in pdfGroups" :key="group.key">
        {{ group.label }} ({{ group.urls.length }})
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="pdfTab">
      <v-tab-item v-for="group in pdfGroups" :key="group.key">
        <div v-if="group.urls.length > 0" class="mt-4">
          <div v-for="(url, index) in group.urls" :key="group.key + '_' + index" class="mb-2">
            <embed :src="apiBase + url" type="application/pdf" width="100%" height="600px" />
          </div>
        </div>
        <div v-else class="grey--text mt-4">
          PDFが生成されていません。「プレビュー生成」ボタンを押してください。
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
export default {
  props: {
    presetId: { type: Number, default: null },
    status: { type: String, default: '' },
    hasPdf: { type: Boolean, default: false },
    questionSheetUrls: { type: Array, default: () => [] },
    answerUrls: { type: Array, default: () => [] },
    answerSheetUrls: { type: Array, default: () => [] },
  },
  data() {
    return {
      composing: false,
      publishing: false,
      unpublishing: false,
      apiBase: this.$axios.defaults.baseURL,
      pdfTab: 0,
    }
  },
  computed: {
    pdfGroups() {
      return [
        { key: 'question', label: '問題用紙', urls: this.questionSheetUrls },
        { key: 'answer', label: '解答', urls: this.answerUrls },
        { key: 'answer_sheet', label: '解答用紙', urls: this.answerSheetUrls },
      ]
    },
  },
  methods: {
    async compose() {
      this.composing = true
      try {
        await this.$axios.post(`/api/v1/admin/presets/${this.presetId}/compose`)
        this.$toasted.global.success({ message: 'プレビューを生成しました' })
        this.$emit('updated')
      } catch (e) {
        const message = e.response && e.response.data && e.response.data.messages
          ? e.response.data.messages
          : 'プレビュー生成に失敗しました'
        this.$toasted.global.error({ message: message })
      }
      this.composing = false
    },
    async publish() {
      this.publishing = true
      try {
        await this.$axios.patch(`/api/v1/admin/presets/${this.presetId}/publish`)
        this.$toasted.global.success({ message: 'プリセットを公開しました' })
        this.$emit('updated')
      } catch (e) {
        const message = e.response && e.response.data && e.response.data.messages
          ? e.response.data.messages
          : '公開に失敗しました'
        this.$toasted.global.error({ message: message })
      }
      this.publishing = false
    },
    async unpublish() {
      this.unpublishing = true
      try {
        await this.$axios.patch(`/api/v1/admin/presets/${this.presetId}/unpublish`)
        this.$toasted.global.success({ message: 'プリセットを非公開にしました' })
        this.$emit('updated')
      } catch (e) {
        this.$toasted.global.error({ message: '非公開への変更に失敗しました' })
      }
      this.unpublishing = false
    },
  },
}
</script>

<style lang="stylus" scoped>
</style>
